import { postsApi } from "../api/posts";
import { debounce } from "lodash";

const DESKTOP_PER_PAGE = 17;
const TABLET_PER_PAGE = 16;
const PHONE_PER_PAGE = 13;

export default () => ({
  page: 1,
  posts: [],
  totalPages: 0,
  categoriesFilter: [],
  windowWidth: window.innerWidth,
  async loadPosts() {
    let perPage;
    if (this.$store.responsive.isDesktop) {
      perPage = this.page === 1 ? DESKTOP_PER_PAGE - 1 : DESKTOP_PER_PAGE;
    } else if (this.$store.responsive.isTablet) {
      perPage = this.page === 1 ? TABLET_PER_PAGE - 1 : TABLET_PER_PAGE;
    } else {
      perPage = this.page === 1 ? PHONE_PER_PAGE - 1 : PHONE_PER_PAGE;
    }
    const response = await postsApi.getPosts({
      perPage: perPage,
      page: this.page,
      categories: this.categoriesFilter,
    });
    this.totalPages = response.pages;
    this.posts.push(...response.data);
    if (this.page === 1 && this.posts.length >= this.subscribeBlockIndex) {
      this.posts.splice(this.subscribeBlockIndex, 0, { id: -1 });
    }
    this.updateURL();
  },
  reset() {
    this.page = 1;
    this.posts = [];
  },
  updateURL() {
    const url = new URL(window.location);
    const params = new URLSearchParams(url.search);

    if (this.categoriesFilter.length > 0) {
      params.set("categories", this.categoriesFilter.join(","));
    } else {
      params.delete("categories");
    }

    url.search = params.toString();
    window.history.replaceState({}, "", url);
  },
  clearCategoriesFilter() {
    if (this.categoriesFilter.length !== 0) {
      this.categoriesFilter = [];
      this.reset();
      this.debounceLoad();
    }
  },
  triggerCategory(categorySlug) {
    if (this.categoriesFilter.includes(categorySlug)) {
      this.categoriesFilter.splice(
        this.categoriesFilter.indexOf(categorySlug),
        1
      );
    } else {
      this.categoriesFilter.push(categorySlug);
    }
    this.reset();
    this.debounceLoad();
  },
  onShowMore() {
    this.page += 1;
    this.debounceLoad();
  },
  onResize() {
    if (this.windowWidth !== window.innerWidth) {
      this.windowWidth = window.innerWidth;
      this.setSubscribeBlockIndex();
      this.reset();
      this.debounceLoad();
    }
  },
  setSubscribeBlockIndex() {
    this.subscribeBlockIndex = this.$store.responsive.isPhone ? 4 : 7;
  },
  init() {
    this.debounceLoad = debounce(() => this.loadPosts(), 500, {
      leading: true,
      trailing: true,
    });
    this.setSubscribeBlockIndex();
    const url = new URL(window.location);
    const params = new URLSearchParams(url.search);

    const categories = params.get("categories");
    if (categories) {
      this.categoriesFilter = categories.split(",");
    }

    addEventListener("resize", this.onResize.bind(this));

    this.loadPosts();
  },
});
